import React from 'react';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const UtilityHookupSection = ({ formData, updateFormData }) => {
  const handleUtilityChange = (utility, checked) => {
    updateFormData('utilities', { ...formData?.utilities, [utility]: checked });
  };

  const getHookupTag = () => {
    const { power, water, sewer } = formData?.utilities;
    if (power && water && sewer) return 'Full Hookup';
    if (power || water || sewer) return 'Partial Hookup';
    return 'Dry Camping';
  };

  const getTagColor = () => {
    const tag = getHookupTag();
    if (tag === 'Full Hookup') return 'bg-success text-success-foreground';
    if (tag === 'Partial Hookup') return 'bg-warning text-warning-foreground';
    return 'bg-secondary text-secondary-foreground';
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-10 h-10 bg-primary rounded-lg">
            <Icon name="Zap" size={20} color="white" />
          </div>
          <div>
            <h3 className="text-lg font-heading font-bold text-foreground">Utility Hookups</h3>
            <p className="text-sm text-muted-foreground">Select available utilities for your sites</p>
          </div>
        </div>
        <span className={`px-3 py-1 rounded-full text-xs font-medium ${getTagColor()}`}>
          {getHookupTag()}
        </span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Checkbox
          label="Electric Power"
          description="30/50 amp electrical hookups"
          checked={formData?.utilities?.power}
          onChange={(e) => handleUtilityChange('power', e?.target?.checked)}
        />

        <Checkbox
          label="Water Connection"
          description="Fresh water hookups"
          checked={formData?.utilities?.water}
          onChange={(e) => handleUtilityChange('water', e?.target?.checked)}
        />

        <Checkbox
          label="Sewer Connection"
          description="Waste water disposal"
          checked={formData?.utilities?.sewer}
          onChange={(e) => handleUtilityChange('sewer', e?.target?.checked)}
        />
      </div>
      <div className="mt-4 p-4 bg-muted rounded-lg">
        <div className="flex items-center space-x-2 text-sm text-muted-foreground">
          <Icon name="Info" size={16} />
          <span>
            Full hookups typically command 20-40% higher rates than dry camping sites
          </span>
        </div>
      </div>
    </div>
  );
};

export default UtilityHookupSection;